import React from "react";
import "./style/glitch_header.scss";

export default function GlitchHeader({ content }: { content: string }) {
  return <div className="hero-container">
    <div className="environment"></div>
    <h1 className="hero glitch layers" data-text={content}><span>{content}</span></h1>
  </div>;
}
